import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private readonly appInsights: ApplicationInsights | undefined;
  private readonly connectionString = environment.appInsightsConnectionString;
  isBrowser: boolean = false;
  constructor(@Inject(PLATFORM_ID) platformId: string) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.appInsights = new ApplicationInsights({
        config: {
          connectionString: this.connectionString,
        },
      });

      this.appInsights.loadAppInsights();
      this.appInsights.trackPageView();
    }
  }

  setAuthenticatedUserContext(userName: string, accountNumber?: string): void {
    if (this.appInsights) {
      this.appInsights.setAuthenticatedUserContext(userName, accountNumber, true);
    }
  }

  clearAuthenticatedUserContext(): void {
    if (this.appInsights) {
      this.appInsights.clearAuthenticatedUserContext();
    }
  }

  logInfo(message: string): void {
    if (this.appInsights) {
      this.appInsights.trackTrace({
        message,
        severityLevel: 1, // Info level
      });
    }
  }

  logError(message: string, error: any): void {
    if (this.appInsights) {
      this.appInsights.trackTrace({
        message,
        severityLevel: 3, // Error level
        properties: { errorDetails: JSON.stringify(error) },
      });
    }
  }

  logCritical(message: string, error: any): void {
    if (this.appInsights) {
      this.appInsights.trackTrace({
        message,
        severityLevel: 4, // Critical level
        properties: { errorDetails: JSON.stringify(error) },
      });
    }
  }

  trackPageView(name?: string, url?: string): void {
    // option to call manually
    if (this.appInsights) {
      this.appInsights.trackPageView({
        name,
        uri: url,
      });
    }
  }
}
